var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinterestSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51404_1944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.028 0.0133057C179.105 0.0133057 0 179.093 0 399.962C0 563.786 98.4767 704.484 239.446 766.342C238.253 738.389 239.185 704.897 246.345 674.519C254.077 642.028 297.868 456.528 297.868 456.528C297.868 456.528 285.104 430.989 285.104 393.268C285.104 333.978 319.452 289.72 362.202 289.72C398.627 289.72 416.163 317.063 416.163 349.763C416.163 386.316 392.868 441.053 380.882 491.704C370.869 534.146 402.154 568.766 443.972 568.766C519.775 568.766 570.831 471.391 570.831 356.093C570.831 268.448 511.783 202.827 404.386 202.827C283.027 202.827 207.484 293.3 207.484 394.356C207.484 429.223 217.706 453.777 233.842 472.792C241.212 481.56 242.249 485.089 239.551 495.103C237.63 502.471 233.271 520.188 231.404 527.192C228.754 537.338 220.559 540.943 211.377 537.233C155.499 514.376 129.504 453.231 129.504 384.422C129.504 270.781 225.334 134.56 415.334 134.56C568.077 134.56 668.631 245.035 668.631 363.665C668.631 520.576 581.362 637.823 452.742 637.823C409.573 637.823 368.948 614.447 355.042 587.934C355.042 587.934 331.8 680.121 326.925 697.89C318.415 728.709 301.811 759.568 286.659 783.589C322.617 794.2 360.646 799.983 400.028 799.983C620.948 799.983 800 620.907 800 399.958C800 179.093 620.948 0.0133057 400.028 0.0133057Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51404_1944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterestSocial);
export default __webpack_public_path__ + "static/media/pinterest-social.fecc4b7a3b4d91e4e2147324fef45098.svg";
export { ForwardRef as ReactComponent };